import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

const fetchPdf = async (candId) => {
  const r = await api.get(`/candidates/${candId}/report.pdf`, { responseType: "blob", params: { t: Date.now() } });
  return URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
};

// Opens the tab synchronously so popup blockers allow it, then loads the PDF into it.
export async function viewReport(candId) {
  const win = window.open("", "_blank");
  if (win) win.document.write("<p style='font-family:sans-serif;padding:24px;color:#475569'>Preparing report…</p>");
  try {
    const url = await fetchPdf(candId);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    win?.close();
    toast.error(fmtErr(err.response?.data?.detail) || "Report failed");
  }
}

export async function downloadReport(candId, name) {
  try {
    const url = await fetchPdf(candId);
    const a = document.createElement("a");
    a.href = url; a.download = `recruitsift-report-${(name || "candidate").replace(/\s+/g, "_")}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    toast.success("Report downloaded");
  } catch (err) { toast.error(fmtErr(err.response?.data?.detail) || "Report failed"); }
}
